import { render, staticRenderFns } from "./GoliaInput.vue?vue&type=template&id=1383e1d8"
import script from "./GoliaInput.vue?vue&type=script&lang=js"
export * from "./GoliaInput.vue?vue&type=script&lang=js"
import style0 from "./GoliaInput.vue?vue&type=style&index=0&id=1383e1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports